import React from "react"
import styles from "./AmountWarning.module.css"
import Modal from "../Modal"

type AmountWariningProps = {
  active: boolean
  setActive: (value: boolean) => void
  onApprove: () => void
  message: string
}

function AmountWarning ({
  active,
  setActive,
  onApprove,
  message,
}: AmountWariningProps) {
  function handleCloseError () {
    setActive(false)
  }

  function onApproveAmount () {
    onApprove()
  }

  return (
    <Modal maxWidth='850px' active={active} onCancel={handleCloseError}>
      <div className={styles.modalContent}>
        <h2>{message}</h2>
        <button
          onClick={onApproveAmount}
          className={styles.cancelButton}
          type='button'
        >
          Ja, fortsätt
        </button>
        <button
          onClick={handleCloseError}
          className={styles.cancelButton}
          type='button'
        >
          Nej, gå tillbaka
        </button>
      </div>
    </Modal>
  )
}

export default AmountWarning
